import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { AppConfigContext } from '@infl-ts/util-app-config';
import { memoize } from '@infl-ts/util-function';
import * as DE from '@nll/datum/lib/DatumEither';
import axios from 'axios';
import { pipe } from 'fp-ts/function';
import * as T from 'fp-ts/Task';
import * as TE from 'fp-ts/TaskEither';
import { useContext, useEffect, useState } from 'react';
import { StreamChat } from 'stream-chat';
import { streamTokenRequestConfig } from './use-stream-token';
var chatClientInstance = memoize(function (apiKey) {
  return StreamChat.getInstance(apiKey, {
    timeout: 6000
  });
});

var makeStreamConnectionError = function makeStreamConnectionError(error) {
  return {
    _tag: 'error',
    error: error
  };
};

var connectUserToChat = function connectUserToChat(_ref) {
  var name = _ref.name,
      avatarUrl = _ref.avatarUrl,
      contactId = _ref.contactId,
      apiKey = _ref.apiKey;
  var chatClient = chatClientInstance(apiKey);
  var wsConnection = chatClient.wsConnection;

  if (chatClient.user && wsConnection && wsConnection.connectionOpen) {
    void wsConnection.isDisconnected && wsConnection.connect();
    return wsConnection.connectionOpen;
  } else {
    return chatClient.connectUser({
      id: contactId,
      name: name,
      image: avatarUrl
    }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return axios.request(streamTokenRequestConfig);

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response.data.token);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
  }
};

export var useConnectUser = function useConnectUser(_ref3) {
  var name = _ref3.name,
      avatarUrl = _ref3.avatarUrl,
      contactId = _ref3.contactId,
      apiKey = _ref3.apiKey,
      _ref3$allowConnection = _ref3.allowConnection,
      allowConnection = _ref3$allowConnection === void 0 ? true : _ref3$allowConnection;

  var _useContext = useContext(AppConfigContext),
      activeLens = _useContext.modes.activeLens;

  var _useState = useState(DE.initial),
      result = _useState[0],
      setResult = _useState[1];

  useEffect(function () {
    setResult(DE.toRefresh);

    if (allowConnection && !activeLens) {
      void pipe(TE.tryCatch(function () {
        return connectUserToChat({
          name: name,
          avatarUrl: avatarUrl,
          contactId: contactId,
          apiKey: apiKey
        });
      }, makeStreamConnectionError), TE.map(function (result) {
        return DE.success(result);
      }), TE.fold(function (err) {
        return T.fromIO(function () {
          return setResult(DE.failure(err));
        });
      }, function (res) {
        return T.fromIO(function () {
          return setResult(res);
        });
      }))();
    } else if (!allowConnection) {
      setResult(DE.failure(makeStreamConnectionError('No connection established')));
    } else {
      setResult(DE.toReplete);
    }
  }, [activeLens, allowConnection, avatarUrl, contactId, name, apiKey]);
  return result;
};